import { Badge } from '@/components/ui/badge';
import { getPropertyStatusName, getUnitStatusName } from '@/lib/property-utils';
import type { PropertyResponseDto, PropertyStatus } from '@portfolio-manager/sdk';
import type React from 'react';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

const getPropertyStatusVariant = (status: PropertyStatus): BadgeVariant => {
  switch (status) {
    case 'operating':
      return 'default';
    case 'sold':
      return 'outline';
    case 'dead':
      return 'destructive';
    default:
      return 'secondary';
  }
};

export interface PropertyStatusBadgeProps {
  property: PropertyResponseDto;
  className?: string;
}

export function PropertyStatusBadge({ property, className }: PropertyStatusBadgeProps): React.ReactElement {
  const singleUnit = property.units.length === 1 ? property.units[0] : null;
  return (
    <Badge variant={getPropertyStatusVariant(property.status)} className={className}>
      {getPropertyStatusName(property.status)}
      {singleUnit !== null && ` / ${getUnitStatusName(singleUnit.status)}`}
    </Badge>
  );
}
